import React from "react"

export default () =>
    <ul style={{ listStyleType: "none" }}>
        <li><a href="https://milesplit.live/meets/711273">2025</a></li>
        <li><a href="https://ma.milesplit.com/meets/640151-brown-bear-invitational-2024/results">2024</a></li>
        <li><a href="https://ma.milesplit.com/meets/576255-brown-bear-invitational-2023/results">2023</a></li>
        <li><a href="https://ma.milesplit.com/meets/503874-brown-bear-invitational-2022/results#.YzjSVuzMJpJ">2022</a></li>
        <li><a href="/brown-bear-invitational/results/2021.txt">2021</a></li>
        <li><a href="/brown-bear-invitational/results/2019.txt">2019</a></li>
    </ul>
